<template>
  <div class="container">
    <h2>Contact Us</h2>
    <p>Have suggestions or need help?  We'd love to hear from you.  Shoot us an email at alohaapps1@gmail.com .</p>
  </div>
</template>

<script>

export default {
  name: 'Contact',

}
</script>

<style scoped>
  .container {
    text-align: left;
  }
</style>
